function hasText(value: unknown): boolean {
  if (typeof value === 'string') return value.trim().length > 0
  if (Array.isArray(value)) return value.some(hasText)
  if (!value || typeof value !== 'object') return false

  const record = value as Record<string, unknown>
  return hasText(record.text) || hasText(record.content) || hasText(record.children)
}

export function shouldUseMarkdownFallback(contentJson: unknown, markdown: string | null | undefined): boolean {
  if (!markdown?.trim()) return false
  if (!Array.isArray(contentJson)) return true
  if (contentJson.length === 0) return true
  return !contentJson.some(hasText)
}
